.checkboxContainer {
  display: inline-block;
  position: relative;
}

.checkbox {
  background-image: url("~images/checkbox-empty.svg");
  height: 24px;
  width: 24px;
}

.nativeCheckbox:checked + .lightCheckbox {
  background-image: url("~images/checkbox-filled.svg");
}

.nativeCheckbox:checked + .darkCheckbox {
  background-image: url("~images/checkbox-filled-dark.svg");
}

.nativeCheckbox {
  opacity: 0; // Visible to Capybara but not to humans
  position: absolute;
  width: 100%;
  height: 100%;
}
